// src/pages/Home.jsx - UPDATED VERSION
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicationCard from '../components/PublicationCard';
import publicationsData from '../data/publications.json';
import projectsData from '../data/projects.json';
import coursesData from '../data/courses.json';

const Home = () => {
  const [yearsExp, setYearsExp] = useState(0);
  const [projectsCount, setProjectsCount] = useState(0);
  const [latestPublications, setLatestPublications] = useState([]);
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [featuredCourses, setFeaturedCourses] = useState([]);
  
  useEffect(() => {
    const animateCounter = (setter, target, duration = 1500) => {
      let start = 0;
      const increment = target / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= target) {
          setter(target);
          clearInterval(timer);
        } else {
          setter(Math.floor(start));
        }
      }, 16);
    };
    
    animateCounter(setYearsExp, 8);
    animateCounter(setProjectsCount, 15);
    
    // Get latest publications (3 most recent)
    const sortedPublications = [...publicationsData]
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .slice(0, 3);
    setLatestPublications(sortedPublications);
    
    // Get featured projects
    const featuredProjs = projectsData
      .filter(project => project.featured)
      .slice(0, 3);
    setFeaturedProjects(featuredProjs);
    
    // Get featured courses
    const featuredCrs = coursesData
      .filter(course => course.featured)
      .slice(0, 3);
    setFeaturedCourses(featuredCrs);
  }, []);

  return (
    <>
{/* Hero Section */}
{/* Hero Section - Simple & Professional */}
<section className="hero-section">
  <div className="hero-container">
    <div className="hero-content">
      {/* Hero Description with Background Frame */}
      <div className="hero-description-container">
        <div className="hero-description-frame">
          <div className="hero-description">
            <p className="lead-paragraph">
              Welcome to my portfolio. I'm Ayoub, a solutions architect with {yearsExp}+ years 
              experience in enterprise software. I share insights on cloud architecture, data systems, 
              and the transition from engineering to technical leadership.
            </p>
          </div>
          
          {/* Learn More Link - INSIDE FRAME at bottom right */}
          <div className="learn-more-container">
            <Link to="/about" className="learn-more-link">
              Learn more
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Latest Publications */}
<section className="section-preview">
  <div className="section-header">
    <h2>Latest Publications</h2>
    <Link to="/publications" className="view-all">
      View All →
    </Link>
  </div>
  <div className="home-publications-grid">
    {latestPublications.map(pub => (
      <div key={pub.id} className={`home-publication-card ${pub.featured ? 'featured' : ''}`}>
        <div className="home-publication-image">
          {pub.image ? (
            <img 
              src={`/images/publications/${pub.id}/main.png`} 
              alt={pub.title}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextElementSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div className="image-placeholder" style={{ display: pub.image ? 'none' : 'flex' }}>
            {pub.category.charAt(0)}
          </div>
          <div className="image-overlay">
            <span className="category-badge">{pub.category}</span>
            {pub.featured && <span className="featured-badge">Featured</span>}
          </div>
        </div>
        
        <div className="home-publication-content">
          <h3>{pub.title}</h3>
          <p className="home-publication-excerpt">{pub.excerpt}</p>
          
          <div className="home-publication-footer">
            <div className="home-publication-meta">
              <span className="home-read-time">{pub.readTime}</span>
            </div>
            <Link to={`/publications/${pub.id}`} className="home-view-link">
              Read
            </Link>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>

    </>
  );
};

export default Home;